import Rebase from 're-base'
import firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyAEDC9mCfuesUANyE8f2zwV4q5cMq14vYY',
  authDomain: 'craven-economics.firebaseapp.com',
  databaseURL: 'https://craven-economics.firebaseio.com',
  projectId: 'craven-economics',
  storageBucket: 'craven-economics.appspot.com',
  messagingSenderId: '781574312250'
}

const firebaseApp = firebase.initializeApp(config)
const base = Rebase.createClass(firebaseApp.database())

export { firebaseApp }
export default base



// WEBPACK FOOTER //
// ./src/base.js